var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { jsx as _jsx } from "react/jsx-runtime";
import { global } from '@navinc/utils';
const { CLIENT_CDN_BASE_URL } = (_b = (_a = global === null || global === void 0 ? void 0 : global.process) === null || _a === void 0 ? void 0 : _a.env) !== null && _b !== void 0 ? _b : {};
/** A simple component for displaying an asset from any passed directory on the CDN. */
export const CDNAsset = (_a) => {
    var { directory, filename } = _a, props = __rest(_a, ["directory", "filename"]);
    return (_jsx("img", Object.assign({ alt: filename }, props, { src: `${CLIENT_CDN_BASE_URL}/${directory}/${filename}` })));
};
export default CDNAsset;
//# sourceMappingURL=cdn-asset.js.map